<!--
* @Name：流程审批
* @Author: 刘玉
* @Date: 2021-12-17 11:12:35
* @Last Modified by: 刘玉
* @Last Modified time: 2021-12-17 11:12:35
-->

<template>
  <div>
    <approval-opinions :opinion-list="opinionList" />
    <van-row style="text-align: center; margin-bottom: 20px">
      <span v-for="item in taskBtns" :key="item.btnName" style="padding-right: 5px">
        <van-button :loading="loading" type="info" size="normal" @click="action(item)" loading-type="spinner">{{
          item.btnName
        }}</van-button>
      </span>
      <van-button type="info" size="normal" @click="close">关闭</van-button>
    </van-row>
    <Agree
      v-if="agreeVisible"
      :task-id="currentTaskId"
      :task-title="taskTitle"
      :next-node="nextNode"
      :loading="loading"
      @cancel="cancelAgree"
      @confirm="confirmAgree"
    />
    <back-to-node
      v-if="backToNodeVisible"
      :task-id="currentTaskId"
      :task-title="taskTitle"
      @cancel="cancelBackToNode"
      @confirm="confirmBackToNode"
    />
  </div>
</template>

<script>
import cloneDeep from 'lodash.clonedeep'
import { callHook } from '@/utils/index'
import {
  getTaskBtn,
  opinionTask,
  saveVariables,
  getNextNode,
  completeTask,
  changeActivity,
  invalidTask
} from '@/api/process'
import Bridge from '@/components/dsbridge'
export default {
  name: 'HiFlowApproval',
  components: {
    'approval-opinions': () => import('./ApprovalOpinions'),
    Agree: () => import('./Agree'),
    'back-to-node': () => import('./BackToNode')
  },
  data() {
    return {
      loading: false,
      opinionList: [],
      taskBtns: [],
      processInfo: {},
      // processInstanceId: this.$store.getters.taskId,
      processInstanceId: this.$route.query.taskId,
      currentTaskId: '',
      taskTitle: '',
      alias: null,
      nextNode: [],
      agreeVisible: false,
      backToNodeVisible: false
    }
  },
  props: {
    pageContext: {
      type: Object,
      default: undefined
    }
  },
  computed: {
    hookContext() {
      return this.pageContext || this.$parent
    }
  },
  mounted() {
    // this.currentTaskId = this.$store.getters.taskId
    this.currentTaskId = this.$route.query.taskId
    this.initTaskBtn()
  },
  methods: {
    async initTaskBtn() {
      try {
        const taskBtnRes = await getTaskBtn(this.currentTaskId)
        if (taskBtnRes && taskBtnRes.code === 0) {
          this.taskBtns = taskBtnRes.data || []
          this.processInstanceId = taskBtnRes.processInstanceId

          this.taskTitle = taskBtnRes.taskTitle
          this.feedbackUser = taskBtnRes.feedbackUser

          this.processInfo.taskDefKey = taskBtnRes.taskDefKey
          this.processInfo.taskName = taskBtnRes.taskName
          this.processInfo.processInstanceId = taskBtnRes.processInstanceId
          this.$emit('get-process-info', cloneDeep(this.processInfo))
          this.initOpinionTask()
        }
      } catch (e) {
        console.error(e)
      }
    },
    async initOpinionTask() {
      const opinionTaskRes = await opinionTask(this.processInstanceId)
      if (opinionTaskRes && opinionTaskRes.code === 0) {
        this.opinionList = opinionTaskRes.data || []
      }
    },
    async action(item) {
      this.alias = item.alias
      try {
        await callHook(
          this.hookContext,
          this.hookContext.$options.bpmHooks,
          'beforeHandler',
          this.alias,
          this.processInfo
        )
        // 设置流程变量
        const variables = await callHook(
          this.hookContext,
          this.hookContext.$options.bpmHooks,
          'setProcessVariables',
          this.alias,
          this.processInfo
        )
        if (variables) {
          await saveVariables(this.processInstanceId, variables)
        }
        switch (this.alias) {
          case 'agree':
            // 同意
            {
              // 修改下一节点
              const params = await callHook(
                this.hookContext,
                this.hookContext.$options.bpmHooks,
                'setNextNode',
                this.alias,
                this.processInfo
              )
              if (params) {
                await this.getNextNode(params)
              } else {
                await this.getNextNode()
              }
              this.agreeVisible = true
            }
            break
          case 'backToNode':
            // 退回
            this.backToNodeVisible = true
            break
          case 'invalid':
            // 终止
            this.invalidTaskAction()
            break
          default:
            break
        }
      } catch (e) {
        console.error(e)
      }
    },
    async getNextNode(params) {
      try {
        this.loading = true
        const response = await getNextNode(this.currentTaskId, params)
        if (response && response.code === 0) {
          this.nextNode = response.data
        }
      } catch (e) {
        console.error(e)
      } finally {
        this.loading = false
      }
    },
    async confirmAgree(data) {
      try {
        this.$toast.loading({
          message: '提交中...',
          forbidClick: true,
          loadingType: 'spinner',
          duration: 0
        })
        // 前置hook
        await callHook(
          this.hookContext,
          this.hookContext.$options.bpmHooks,
          'beforeExecute',
          this.alias,
          this.processInfo
        )
        const response = await completeTask(data)
        if (response && response.code === 0) {
          // 后置hook
          await callHook(
            this.hookContext,
            this.hookContext.$options.bpmHooks,
            'afterExecute',
            this.alias,
            this.processInfo
          )
          this.cancelAgree()
          this.close()
        } else {
          this.$notify({ type: 'warning', message: response.msg })
        }
      } catch (e) {
        console.error(e)
      } finally {
        this.$toast.clear()
      }
    },
    cancelAgree() {
      this.agreeVisible = false
    },
    async confirmBackToNode(data) {
      try {
        // 前置hook
        await callHook(
          this.hookContext,
          this.hookContext.$options.bpmHooks,
          'beforeExecute',
          this.alias,
          this.processInfo
        )
        const response = await changeActivity(data)
        if (response && response.code === 0) {
          // 后置hook
          await callHook(
            this.hookContext,
            this.hookContext.$options.bpmHooks,
            'afterExecute',
            this.alias,
            this.processInfo
          )
          this.cancelBackToNode()
          this.close()
        } else {
          this.$notify({ type: 'warning', message: response.msg })
        }
      } catch (e) {
        console.error(e)
      }
    },
    cancelBackToNode() {
      this.backToNodeVisible = false
    },
    async invalidTaskAction() {
      try {
        // 前置hook
        await callHook(
          this.hookContext,
          this.hookContext.$options.bpmHooks,
          'beforeExecute',
          this.alias,
          this.processInfo
        )
        const response = await invalidTask(this.currentTaskId)
        if (response && response.code === 0) {
          // 后置hook
          await callHook(
            this.hookContext,
            this.hookContext.$options.bpmHooks,
            'afterExecute',
            this.alias,
            this.processInfo
          )
          this.$notify({ type: 'success', message: '作废成功' })
          this.close()
        }
      } catch (e) {
        console.error(e)
      }
    },
    close() {
      // this.$router.push('/todo')
      Bridge.callMethodSyn('app.jsLeavePage', '')
    }
  }
}
</script>
